export default "__VITE_ASSET__AMoBo5Pv__"